<section class="w-full max-w-2xl flex flex-col gap-5">
  <p class="text-sm text-gray-600">
    Importez vos clients en masse à partir d'un fichier Excel (.xlsx) conforme au modèle ci-dessous.
  </p>

  <div class="rounded-xl border border-gray-200 overflow-hidden bg-gray-50">
    <img
      [src]="templatePreviewUrl"
      alt="Aperçu du modèle d'import Excel"
      class="w-full h-auto"
    />
    <p class="px-3 py-2 text-xs text-gray-500 border-t border-gray-200 bg-white">
      Le modèle téléchargeable inclut aussi les colonnes optionnelles « Nom du contact » et « Email du contact ».
    </p>
  </div>

  <div class="rounded-xl border border-gray-200 bg-white p-4 space-y-2">
    <h3 class="text-sm font-semibold text-gray-900">Colonnes attendues</h3>
    <ul class="text-sm text-gray-600 space-y-1 list-disc list-inside">
      <li><span class="font-medium text-gray-800">Siret</span> — 14 chiffres (texte ou nombre)</li>
      <li><span class="font-medium text-gray-800">Nom d'utilisateur impots.gouv</span></li>
      <li><span class="font-medium text-gray-800">Mot de passe impots.gouv</span></li>
      <li><span class="font-medium text-gray-800">Nom du contact</span> — optionnel</li>
      <li><span class="font-medium text-gray-800">Email du contact</span> — optionnel</li>
    </ul>
  </div>

  <div class="rounded-xl border border-amber-200 bg-amber-50 p-4 space-y-2">
    <h3 class="text-sm font-semibold text-amber-900">Contrôles à l'import</h3>
    <ul class="text-sm text-amber-900/90 space-y-1 list-disc list-inside">
      <li>Chaque SIRET doit contenir exactement 14 chiffres.</li>
      <li>Le nom d'utilisateur et le mot de passe impots.gouv doivent être renseignés sur chaque ligne.</li>
      <li>Le nom et l'email de contact sont optionnels ; s'ils sont fournis, ils seront enregistrés sur le compte client.</li>
      <li>Le cas de plusieurs entreprises gérées par le même compte impots.gouv est accepté : renseignez simplement les différents SIRET avec les mêmes identifiants.</li>
      <li>En cas d'erreur, le fichier est rejeté et aucune entreprise n'est importée : corrigez le fichier et réessayez.</li>
    </ul>
  </div>

  @if (atCompanyLimit()) {
    <p class="text-sm text-amber-700">
      Limite de clients atteinte. Supprimez un client avant d'importer.
    </p>
  }

  <div class="flex flex-wrap justify-end gap-2 pt-1">
    <button
      type="button"
      class="rounded-md border border-gray-300 px-4 py-2 text-sm cursor-pointer hover:bg-gray-50"
      (click)="close()"
    >
      Annuler
    </button>
    <button
      type="button"
      class="rounded-md border border-gray-300 px-4 py-2 text-sm cursor-pointer hover:bg-gray-50 disabled:opacity-60"
      [disabled]="downloadingTemplate()"
      (click)="downloadTemplate()"
    >
      @if (downloadingTemplate()) { Téléchargement... } @else { Télécharger le modèle }
    </button>
    <label
      for="bulk-import-file-input"
      class="rounded-md bg-secondary text-white px-4 py-2 text-sm"
      [class.cursor-pointer]="!atCompanyLimit() && !uploading()"
      [class.hover:bg-secondary-hover]="!atCompanyLimit() && !uploading()"
      [class.opacity-60]="atCompanyLimit() || uploading()"
      [class.cursor-not-allowed]="atCompanyLimit() || uploading()"
    >
      @if (uploading()) { Import en cours... } @else { Importer le fichier }
    </label>
    <input
      id="bulk-import-file-input"
      type="file"
      accept=".xlsx,.xls"
      class="hidden"
      [disabled]="atCompanyLimit() || uploading()"
      (change)="onFileSelected($event)"
    />
  </div>
</section>
